<template>
    <div class="flex flex-column justify-content-start gap-2 p-4">
        <span class="H6-Medium text-center py-4">Exam Results</span>
        <div class="grid">
            <div class="col-12 md:col-6">
                <div class="detail-item flex flex-wrap align-items-baseline gap-2">
                    <span class="Paragraph-Medium whitespace-nowrap">Subject –</span>
                    <div class="Paragraph-Regular value-content">{{ result.subject }}</div>
                </div>
                <div class="detail-item flex flex-wrap align-items-baseline gap-2">
                    <span class="Paragraph-Medium whitespace-nowrap">Exam Name –</span>
                    <div class="Paragraph-Regular value-content">{{ result.examName }}</div>
                </div>
            </div>

            <div class="col-12 md:col-6">
                <div class="detail-item flex flex-wrap align-items-baseline gap-2">
                    <span class="Paragraph-Medium whitespace-nowrap">Date –</span>
                    <div class="Paragraph-Regular value-content">{{ formatToDisplayDate(result.date) }}</div>
                </div>
                <div class="detail-item flex flex-wrap align-items-baseline gap-2">
                    <span class="Paragraph-Medium whitespace-nowrap">Marks –</span>
                    <div class="Paragraph-Regular value-content">{{ result.marks }}</div>
                </div>
            </div>

            <div class="col-12">
                <div class="detail-item flex flex-wrap align-items-baseline gap-2">
                    <span class="Paragraph-Medium whitespace-nowrap">Feedback –</span>
                    <div class="Label value-content" v-html="result.feedback"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
import { defineProps } from "vue";
import { formatToDisplayDate } from "@/utils/cleanups";

defineProps({
    result: {
        type: Object,
        required: true,
    },
});
</script>

<style scoped>
.detail-item {
    margin-bottom: 1rem;
}

.detail-item>span,
.detail-item>div {
    display: inline-block;
    margin-right: 0.5rem;
}

.detail-item .Paragraph-Medium {
    margin-right: 0.5rem;
}

.detail-item.flex {
    display: flex;
    align-items: flex-start;
}

.value-content {
    flex: 1 1 300px;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
    display: block;
}
</style>